interface Props {
  readonly children: string;
}

export const NoPrimaryWrapper = ({ children }: Readonly<Props>) => (
  <>{children}</>
);
